export const EMPTY_ROOM_INBOX = Object.freeze({
  activityVersion: 0,
  totalUnreadCount: 0,
  rooms: [],
  roomsById: Object.freeze({}),
});

const toNonNegativeInteger = (value) => {
  const number = Number(value);
  return Number.isFinite(number) && number > 0 ? Math.floor(number) : 0;
};

const toStringOrNull = (value) => {
  if (value == null) return null;
  const normalized = String(value).trim();
  return normalized || null;
};

const normalizeEncryptedPreview = (value) => {
  const ciphertextB64 = toStringOrNull(value?.ciphertext_b64);
  const ivB64 = toStringOrNull(value?.iv_b64);
  if (!ciphertextB64 || !ivB64) return null;

  return {
    ciphertextB64,
    ivB64,
    algorithm: toStringOrNull(value?.alg),
  };
};

export const normalizeRoomInboxSnapshot = (payload) => {
  const raw = payload?.room_inbox || payload || {};
  const rooms = (Array.isArray(raw.rooms) ? raw.rooms : [])
    .map((room) => ({
      roomId: toStringOrNull(room?.room_id),
      conversationId: toStringOrNull(room?.conversation_id),
      unreadCount: toNonNegativeInteger(room?.unread_count),
      notificationsMuted: room?.notifications_muted === true,
      membershipRole: toStringOrNull(room?.membership_role),
      lastActivityAt: toStringOrNull(room?.last_activity_at),
      lastServerSeq: room?.last_server_seq == null ? null : toNonNegativeInteger(room.last_server_seq),
      encryptedPreview: normalizeEncryptedPreview(room?.encrypted_preview),
      latestMessagePreview: null,
    }))
    .filter((room) => room.roomId);

  return {
    activityVersion: toNonNegativeInteger(raw.activity_version),
    totalUnreadCount: toNonNegativeInteger(raw.total_unread_count),
    rooms,
    roomsById: Object.fromEntries(rooms.map((room) => [room.roomId, room])),
  };
};

export const createInitialRoomInboxState = () => ({
  snapshot: EMPTY_ROOM_INBOX,
  lifecycleEvent: null,
  status: 'idle',
  error: null,
  hasLoaded: false,
});

export const roomInboxReducer = (state, action) => {
  switch (action.type) {
    case 'reset':
      return createInitialRoomInboxState();
    case 'loading':
      return {
        ...state,
        status: state.hasLoaded ? 'refreshing' : 'loading',
        error: null,
      };
    case 'success':
      if (action.snapshot.activityVersion < state.snapshot.activityVersion) return state;
      return {
        snapshot: action.snapshot,
        lifecycleEvent: state.lifecycleEvent,
        status: 'ready',
        error: null,
        hasLoaded: true,
      };
    case 'lifecycle': {
      const version = toNonNegativeInteger(action.event?.version);
      const currentVersion = toNonNegativeInteger(state.lifecycleEvent?.version);
      if (!action.event?.kind || version <= currentVersion) return state;
      return {
        ...state,
        lifecycleEvent: action.event,
      };
    }
    case 'error':
      return {
        ...state,
        status: state.hasLoaded ? 'ready' : 'error',
        error: action.error,
      };
    default:
      return state;
  }
};
